module.exports = __webpack_public_path__ + "static/media/talk03_small@2x.f12304e5.jpg";